import { makeStyles } from '@material-ui/core';
import { getContrastTextColor } from '../../utils/themeHelpers';

const useStyles = makeStyles(
  (theme) => ({
    wrapper: ({ style, isInteractive }) => ({
      position: 'relative',
      overflow: 'hidden',
      padding: '8px',
      cursor: isInteractive ? 'pointer' : 'inherit',
      // backgroundColor: theme.colors.inputFieldsBackground,
      ...style,
      ...style?.wrapper,

      '&:hover': {
        backgroundColor: isInteractive ? theme.colors.experienceActiveBackgroundColor : '',
        ...style?.hover,
      },
    }),
    active: ({ style }) => ({
      backgroundColor: theme.colors.experienceActiveBackgroundColor,
      color: getContrastTextColor(theme.colors.experienceActiveBackgroundColor),
      border: `1px solid ${theme.colors.charcoal}`,
      ...style?.active,

      '&:hover': {
        backgroundColor: theme.colors.experienceActiveBackgroundColor,
      },
    }),
  }),
  { name: 'Card' },
);

export default useStyles;
